import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

import App from './App';
// import registerServiceWorker from './registerServiceWorker';

// var ref = window.document.getElementsByTagName("script")[0];
// var script = window.document.createElement("script");
// script.src = src;
// script.id = "gmaps";
// script.async = true;
// ref.parentNode.insertBefore(script, ref);


// localStorage.setItem("protection_channel_redirect", true);
// localStorage.setItem("protection_channel_redirect_url", "http://localhost:3000/join/#/protection-channel");
// localStorage.setItem("protection_channel_step", true);

// localStorage.setItem("advertisement_redirect", true);
// localStorage.setItem("advertisement_redirect_url", "http://localhost:3000/join/#/advertisement");
// localStorage.setItem("advertisement_step", true);

ReactDOM.render(<App />, document.getElementById('root'));
// registerServiceWorker();
